module.exports = __webpack_public_path__ + "img/1486149760.b8e2b090.jpg";